import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMicrophone = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M10.0013 13.5391C7.81797 13.5391 6.04297 11.7641 6.04297 9.58073V4.9974C6.04297 2.81406 7.81797 1.03906 10.0013 1.03906C12.1846 1.03906 13.9596 2.81406 13.9596 4.9974V9.58073C13.9596 11.7641 12.1846 13.5391 10.0013 13.5391ZM10.0013 2.28906C8.50964 2.28906 7.29297 3.50573 7.29297 4.9974V9.58073C7.29297 11.0724 8.50964 12.2891 10.0013 12.2891C11.493 12.2891 12.7096 11.0724 12.7096 9.58073V4.9974C12.7096 3.50573 11.493 2.28906 10.0013 2.28906Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10 16.4557C6.14167 16.4557 3 13.3141 3 9.45573V8.03906C3 7.6974 3.28333 7.41406 3.625 7.41406C3.96667 7.41406 4.25 7.6974 4.25 8.03906V9.45573C4.25 12.6224 6.83333 15.2057 10 15.2057C13.1667 15.2057 15.75 12.6224 15.75 9.45573V8.03906C15.75 7.6974 16.0333 7.41406 16.375 7.41406C16.7167 7.41406 17 7.6974 17 8.03906V9.45573C17 13.3141 13.8583 16.4557 10 16.4557Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.1599 5.9849C11.0932 5.9849 11.0182 5.97656 10.9432 5.95156C10.3349 5.72656 9.66819 5.72656 9.05986 5.95156C8.73486 6.06823 8.37653 5.90156 8.25986 5.57656C8.14319 5.25156 8.30986 4.89323 8.63486 4.77656C9.51819 4.4599 10.4932 4.4599 11.3765 4.77656C11.7015 4.89323 11.8682 5.25156 11.7515 5.57656C11.6515 5.82656 11.4099 5.9849 11.1599 5.9849Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.6671 7.75156C10.6087 7.75156 10.5587 7.74323 10.5004 7.72656C10.1671 7.6349 9.82539 7.6349 9.49206 7.72656C9.15872 7.81823 8.81706 7.61823 8.72539 7.2849C8.63372 6.9599 8.83372 6.61823 9.16706 6.52656C9.70872 6.37656 10.2921 6.37656 10.8337 6.52656C11.1671 6.61823 11.3671 6.9599 11.2754 7.29323C11.2004 7.56823 10.9421 7.75156 10.6671 7.75156Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10 18.9609C9.65833 18.9609 9.375 18.6776 9.375 18.3359V15.8359C9.375 15.4943 9.65833 15.2109 10 15.2109C10.3417 15.2109 10.625 15.4943 10.625 15.8359V18.3359C10.625 18.6776 10.3417 18.9609 10 18.9609Z",
			fill: "white"
		})
	]
});
export default SvgMicrophone;
